/**
 * A processor bug can stringify a non-string value into a field, leaving the literal
 * "[object Object]" (seen in prod FinalJobs, e.g. responsibilities_en). Never render it.
 */
function isJunkEntry(value: string): boolean {
  return value.trim() === '' || value.trim() === '[object Object]';
}

/**
 * Job facet fields are usually string arrays but can arrive as a single string from
 * some crawlers or legacy records. Returns a safe array for iteration.
 */
export function coerceStringArrayField(value: unknown): string[] {
  if (Array.isArray(value)) {
    return value.filter((item): item is string => typeof item === 'string' && !isJunkEntry(item));
  }
  if (typeof value === 'string' && !isJunkEntry(value)) {
    return [value];
  }
  return [];
}
